module.exports = __webpack_public_path__ + "img/323.47b0e818.png";